import React, { createContext, useState } from "react";

// Create the context
export const StudyContext = createContext();

// Create the provider component
export const StudyProvider = ({ children }) => {
  const [studyData, setStudyData] = useState(null);
  // console.log("🚀 ~ StudyProvider ~ studyData:", studyData);

  return (
    <StudyContext.Provider value={{ studyData, setStudyData }}>
      {children}
    </StudyContext.Provider>
  );
};
